<!-- 图片上传 -->
<template>
  <el-upload
    ref="upload"
    class="image-upload"
    action=""
    drag
    list-type="text"
    :on-change="handleChange"
    :show-file-list="false"
    :auto-upload="false"
  >
    <el-image v-if="imageUrl" :src="imageUrl" class="avatar" fit="scale-down">
      <div slot="error" class="error">
        <img :src="error">
      </div>
    </el-image>
    <i v-else class="el-icon-plus avatar-uploader-icon" />
  </el-upload>
</template>

<script>
export default {
  name: 'ImageUpload',
  components: {},
  model: {
    prop: 'base64',
    event: 'change'
  },
  props: {
    base64: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imageTypeList: ['jpg', 'jpeg', 'png'],
      imageUrl: ''
    }
  },
  watch: {
    base64 (val) {
      this.imageUrl = val
    }
  },
  created () {
    this.imageUrl = this.base64 || this.url
  },
  methods: {
    // 添加图片时触发事件
    handleChange (file, fileList) {
      const { name } = file
      const extension = name.split('.').pop()
      if (!this.imageTypeList.includes(extension)) {
        this.$message({
          type: 'warning',
          message: '请上传符合格式的图片文件',
          duration: 1 * 1000
        })
        fileList.splice(-1, 1)
      } else {
        if (fileList.length > 1) {
          fileList.splice(0, 1)
        }
        const reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = () => {
          this.imageUrl = reader.result
          this.$emit('change', reader.result)
        }
      }
    },
    // 获取图片的base64
    getBase64 () {
      return this.base64
    },
    // 设置图片地址
    setUrl (url) {
      this.imageUrl = url
    },
    // 清除图片
    clear () {
      this.base64 = ''
      this.imageUrl = require('@/assets/image/station.png')
      this.$refs.upload.clearFiles()
    }
  }
}
</script>
<style scoped>
.image-upload{
  width: fit-content;
  border: thin dashed var(--primary-color);
  padding: 10px;
}
.image-upload .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image-upload .el-upload:hover {
  border-color: #409eff;
}
.image-upload-icon {
  position: absolute;
  top: calc(50% - 14px);
  left: calc(50% - 14px);
  font-size: 28px;
  color: #8c939d;
}
* ::v-deep .el-upload-dragger {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1c2550;
  border-style: hidden;
}
.avatar {
  height: 180px;
  width: 360px;
  display: inline-block;
}
::v-deep .error img {
  display: inline-block;
  width: 228px;
  height: 58px;
}

</style>
